// Pointy-top axial → pixel coordinate math for SVG rendering.
// Separate from @tessera/engine which stays purely grid-logical.
import type { AxialCoord } from '@tessera/engine';

export const TILE_SIZE = 34; // hex "size" = radius from center to corner

export function axialToPixel(c: AxialCoord): { x: number; y: number } {
  const s = TILE_SIZE;
  const x = s * Math.sqrt(3) * (c.q + c.r / 2);
  const y = s * (3 / 2) * c.r;
  return { x, y };
}

// Six corner offsets for a pointy-top hex of given size.
export function hexCorners(size: number): { x: number; y: number }[] {
  const out: { x: number; y: number }[] = [];
  for (let i = 0; i < 6; i++) {
    const angle = Math.PI / 180 * (60 * i - 30);
    out.push({ x: size * Math.cos(angle), y: size * Math.sin(angle) });
  }
  return out;
}

export function hexPath(size: number): string {
  const corners = hexCorners(size);
  return corners.map((c, i) => (i === 0 ? 'M' : 'L') + c.x.toFixed(2) + ',' + c.y.toFixed(2)).join(' ') + ' Z';
}

// Eight muted tile colors per "Quiet Paper" discipline (2 unused reserved).
export const TILE_PALETTE = [
  '#C7613A', // terracotta
  '#3F6F8B', // muted steel blue
  '#8A6E3C', // brass
  '#5E7A58', // sage
  '#7B4F6E', // plum
  '#38514E', // deep teal
];

export function tileFill(color: number): string {
  return TILE_PALETTE[color % TILE_PALETTE.length]!;
}
